import React, { useState, useRef, useEffect } from 'react';

const TypeArticleSelectDropdown = ({
  value,
  onChange,
  options,
  loading,
  disabled,
  isDarkMode,
  required,
  placeholder = "Sélectionner un type d'article"
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const filteredOptions = options.filter(
    (type) =>
      type.designation?.toLowerCase().includes(search.toLowerCase())
  );

  const selected = options.find((t) => String(t.id) === String(value));

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className={`w-full px-4 py-3 border rounded-lg text-left flex justify-between items-center ${
          isDarkMode
            ? 'bg-gray-800 border-gray-600 text-white'
            : 'bg-white border-gray-300 text-gray-900'
        }`}
        onClick={() => !disabled && setOpen((v) => !v)}
        disabled={disabled}
        tabIndex={0}
      >
        <span>
          {selected
            ? selected.designation
            : loading
            ? 'Chargement...'
            : placeholder}
        </span>
        <i className={`fas fa-chevron-down ml-2 ${open ? 'rotate-180' : ''}`}></i>
      </button>
      {open && (
        <div
          className={`absolute z-50 left-0 right-0 mt-2 rounded-lg shadow-lg border ${
            isDarkMode
              ? 'bg-gray-800 border-gray-600'
              : 'bg-white border-gray-200'
          }`}
        >
          {/* Fixed search input */}
          <div className="p-2 border-b border-gray-200 sticky top-0 z-10 bg-inherit">
            <input
              type="text"
              autoFocus
              placeholder="Rechercher..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={`w-full px-3 py-2 border rounded ${
                isDarkMode
                  ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                  : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-500'
              }`}
            />
          </div>
          <div className="max-h-60 overflow-auto">
            {filteredOptions.length === 0 && (
              <div className={`px-4 py-2 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Aucun type trouvé
              </div>
            )}
            {filteredOptions.map((type) => (
              <button
                key={type.id}
                type="button"
                className={`w-full text-left px-4 py-2 hover:bg-primary-50 ${
                  isDarkMode
                    ? String(value) === String(type.id)
                      ? 'bg-primary-700 text-white'
                      : 'text-white hover:bg-gray-700'
                    : String(value) === String(type.id)
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-900'
                }`}
                onClick={() => {
                  onChange(type.id);
                  setOpen(false);
                  setSearch('');
                }}
              >
                {type.designation}
              </button>
            ))}
          </div>
        </div>
      )}
      {required && (
        <input
          tabIndex={-1}
          style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
          value={value || ''}
          required
          readOnly
        />
      )}
    </div>
  );
};

export default TypeArticleSelectDropdown;